<div class="generic-card" [class]="config.options?.mainClass">
  <mat-card appearance="outlined">
    @if (config.options && config.options.statusIcon && config.options.statusIcon.type) {
      <div class="status-indicator">
        <mat-icon
          [class.active]="config.options.statusIcon.type === 'active'"
          [class.warning]="config.options.statusIcon.type === 'warning'"
        >
          fiber_manual_record
        </mat-icon>

      </div>
    }


    @if (config.header) {
      <mat-card-header>
        @if (config.header.title) {
          <mat-card-title class="card-header-title">{{ config.header.title }}</mat-card-title>
        }
        @if (config.header.subtitle) {
          <mat-card-subtitle>{{ config.header.subtitle }}</mat-card-subtitle>
        }
      </mat-card-header>
    }

    <mat-card-content>
      <div class="card-grid">
        @for (section of config.sections; track section.title) {
          <div class="info-group">
            @if (section.title) {
              <h4 class="text-overflow">{{ section.title }}</h4>
            }
            @for (field of section.fields; track field.label) {
              @if (field.visible !== false) {
                <div class="info-row">
                  <span class="label">{{ field.label }}:</span>
                  <span class="value">
                    @if (Array.isArray(field.value)) {
                      @if (field.value.length === 0) {
                        -
                      } @else {
                        @for (line of field.value; track $index; let last = $last) {
                          {{ line }}
                          @if (!last) {
                            <br>
                          }
                        }
                      }

                    } @else {
                      {{ field.value || '-' }}
                    }
                  </span>
                </div>
              }
            }
          </div>
        }
      </div>
    </mat-card-content>
    @if (config.actions) {
      <mat-card-actions class="card-actions-container">
        <!-- Left section -->
        <div class="actions-section left">
          @if (config.actions.left?.length) {

            @for (action of config.actions.left; track action.id) {
              <span
                [matTooltip]="action.tooltip || ''"
                [matTooltipDisabled]="!action.tooltip"
                class="button-wrapper"
              >
                <button mat-stroked-button
                        [color]="action.type"
                        [disabled]="action.disabled"
                        class="action-button"
                        (click)="onActionClick(action)">
                  {{ action.label }}
                </button>
              </span>
            }
          }
        </div>

        <!-- Right section -->
        <div class="actions-section right">
          @if (config.actions.right?.length) {
            @for (action of config.actions.right; track action.id) {
              <span
                [matTooltip]="action.tooltip || ''"
                [matTooltipDisabled]="!action.tooltip"
                class="button-wrapper"
              >
                <button mat-stroked-button
                        [color]="action.type"
                        [disabled]="action.disabled"
                        class="action-button"
                        (click)="onActionClick(action)">
                  {{ action.label }}
                </button>
              </span>
            }
          }
        </div>
      </mat-card-actions>

    }


  </mat-card>
</div>
